/* ============================================================================
   Farmkart Sticky ATC Bar
   Snippet : snippets/sticky-atc-bar.liquid
   Styles  : assets/pdp-buy-box.css (.fk-sticky-atc)

   Shows the sticky bottom bar when the main ATC button scrolls off-screen.
   Updates price display when the variant changes (via theme pubsub).
   Submits the main product form when the sticky ATC button is tapped.
   ============================================================================ */
(function () {
  'use strict';

  function init() {
    var bar     = document.getElementById('fk-sticky-atc');
    var stickyBtn = document.getElementById('fk-sticky-atc-btn');
    var priceEl = document.getElementById('fk-sticky-price');

    if (!bar) return;

    var targetId = bar.getAttribute('data-target-id');
    var formId   = bar.getAttribute('data-form-id');
    var mainBtn  = document.getElementById(targetId);
    var form     = document.getElementById(formId);

    if (!mainBtn || !form) return;

    // ── IntersectionObserver: show bar only after user has scrolled past ATC ──
    // hasSeen prevents the bar appearing on page load when the ATC button is
    // simply below the fold but the user hasn't scrolled to it yet.
    var hasSeen = false;
    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (entry.isIntersecting) {
          hasSeen = true;
          bar.classList.remove('is-visible');
        } else if (hasSeen) {
          bar.classList.add('is-visible');
        }
      },
      { threshold: 0 }
    );
    observer.observe(mainBtn);

    // ── Sticky button submits the main product form ──────────────────────────
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.disabled) return;
        // Trigger the main form's submit to reuse all validation + ATC logic
        var submitEvent = new Event('submit', { bubbles: true, cancelable: true });
        form.dispatchEvent(submitEvent);
        // Fallback: direct button click if form submit didn't fire ATC
        var mainSubmit = document.getElementById(targetId);
        if (mainSubmit && !mainSubmit.disabled) mainSubmit.click();
      });
    }

    // ── Update price + availability on variant change (theme pubsub) ─────────
    if (typeof subscribe === 'function') {
      subscribe('variant-change', function (event) {
        var variant = event && event.data && event.data.variant;
        if (!variant) return;

        // Format price as ₹N (replicates money_without_trailing_zeros for INR)
        var inr = Math.round((variant.price || 0) / 100);
        var formatted = '₹' + inr.toLocaleString('en-IN');

        // Update sticky bar price
        if (priceEl) priceEl.textContent = formatted;

        // Update main ATC button price span (fk-atc-price-{sectionId})
        var sectionId = formId ? formId.replace('product-form-', '') : '';
        if (sectionId) {
          var mainPriceEl = document.getElementById('fk-atc-price-' + sectionId);
          if (mainPriceEl) {
            mainPriceEl.textContent = variant.available ? ' — ' + formatted : '';
          }
        }

        // Availability
        if (stickyBtn) {
          if (variant.available) {
            stickyBtn.disabled = false;
            stickyBtn.textContent = 'Add to Bag';
          } else {
            stickyBtn.disabled = true;
            stickyBtn.textContent = 'Sold Out';
          }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
